module.exports = __webpack_public_path__ + "img/horloger_prod_LB_066.44fc828d.jpg";